import styled, { css } from 'styled-components';
import {
  firefly,
  paradigmBlue,
  blackPearl,
  blackTangaroa,
  tangaroa,
} from '@paradigm/design-system/src/colors';
import filtersIcon from '@paradigm/design-system/src/assets/icon-filters.svg';
import { MOBILE_BREAKPOINT } from '#/containers/layout/constants';
import BaseButton from '@paradigm/design-system/src/components/Button';

export interface Props {
  readonly onClick: () => void;
  readonly activeFiltersCount: number;
  readonly small?: boolean;
  readonly isBottomTab?: boolean;
  readonly ariaLabel?: string;
  readonly isLeaderboard?: boolean;
  readonly [x: string]: string | number | boolean | (() => void) | undefined;
}
export default function FilterButton({
  onClick,
  activeFiltersCount,
  small = false,
  isBottomTab = false,
  isLeaderboard = false,
  ariaLabel = 'open filter modal',
  ...rest
}: Props) {
  const activeFilters = activeFiltersCount > 0;
  return (
    <Button
      {...rest}
      ariaLabel={ariaLabel}
      onClick={onClick}
      active={activeFilters}
      isBottomTab={isBottomTab}
      small={small}
      isLeaderboard={isLeaderboard}
    >
      <Icon src={filtersIcon} alt="filter-icon" />
      Filters
      {activeFilters && <Badge aria-label="badge">{activeFiltersCount}</Badge>}
    </Button>
  );
}

const Icon = styled.img`
  height: 14px;
  width: 14px;
  margin-right: 10px;
`;
interface ButtonProps {
  isBottomTab: boolean;
  active: boolean;
  small: boolean;
  isLeaderboard: boolean;
}

const Button = styled(BaseButton).attrs((props: ButtonProps) => ({
  size: props.small ? 'medium' : 'large',
  variant: 'squared',
  theme: 'secondary-dark-blue',
}))<ButtonProps>`
  opacity: 0.8;
  background: ${firefly};
  color: #ffffff;
  border: ${(props) =>
    `2px solid ${props.active ? `${paradigmBlue}80` : blackPearl}`};
  border-radius: 3px;
  padding: 0 12px;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    opacity: 0.8;
    background-color: transparent;
    ${(props) =>
      props.isBottomTab
        ? css`
            border: 2px solid ${props.active ? `${paradigmBlue}80` : blackPearl};
            height: 28px;
          `
        : css`
            border: 2px solid
              ${props.active
                ? `${paradigmBlue}80`
                : props.isLeaderboard
                ? tangaroa
                : blackTangaroa};
            height: 34px;
          `}
  }
`;

const Badge = styled.span`
  background-color: #0e69ee;
  position: absolute;
  top: -8px;
  right: -8px;
  font-family: 'IBM Plex Sans';
  font-size: 12px;
  line-height: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  border-radius: 8px;
  width: 16px;
  height: 16px;
`;
